module.exports = __webpack_public_path__ + "static/media/redeem.f4ee3ca6.png";